export const errorBoundaryTitle = (boundaryLevel: string) =>
    `Sorry... there was an error in the ${boundaryLevel}`

export const errorBoundaryText =
    'Please refresh the page or contact the support'
